import Modal from "@/common/elements/Modal";
import CommonReportActionHeader from "../CommonReport/CommonReportActionHeader";
import {
  StyledFlex,
  StyledGridCol,
  StyledGridRow,
  StyledSectionHeading,
} from "@/common/styles";
import deptBadge from "@/assets/Dept_Badge.png";
import Table from "@/common/elements/Table";
import {
  StyledReportContainer,
  StyledReportContent,
} from "../CommonReport/styles";
import { useSelector } from "react-redux";
import {
  getOptionsFromRefList,
  getRefListNameByID,
  isNonEmptyVariable,
} from "@/util/common_function";
import { PHOTOS_BASE_URL } from "@/util/api";
import exportComponentAsPDF from "@/util/export_file";
import { useRef } from "react";

const TransportDocumentModal = ({ show = false, onHide }) => {
  const { bookings } = useSelector((state) => state?.bookings);
  const reportRef = useRef();

  const getFinalPath = (path) => {
    if (path?.includes("\\")) {
      const splitPath = path?.split("/");
      if (splitPath?.length === 4) {
        splitPath.shift();
        splitPath.shift();
      }

      return splitPath?.join("\\");
    }
    return path;
  };

  const handleExportClick = () => {
    exportComponentAsPDF(reportRef, "housetrack-transport-docs.pdf");
  };

  const handlePrintClick = () => {
    // const printContent = reportRef.current;
    // const WindowPrint = window.open("", "", "width=900,height=600");
    // WindowPrint.document.write(printContent.innerHTML);
    // WindowPrint.document.close();
    // WindowPrint.focus();
    // WindowPrint.print();
    // WindowPrint.close();
  };

  return (
    <>
      <Modal
        header="BI2 technologies Report"
        show={show}
        onHide={onHide}
        size="xl"
      >
        <CommonReportActionHeader
          onClose={onHide}
          onExportClick={handleExportClick}
          handlePrintClick={handlePrintClick}
        />

        <StyledReportContainer ref={reportRef}>
          <StyledReportContent>
            <StyledGridRow>
              <StyledGridCol xs={24}>
                <StyledFlex justify="space-between" marginTop="20px">
                  <div>
                    <img
                      src={deptBadge}
                      alt="log here"
                      style={{ maxWidth: "120px" }}
                    />
                  </div>
                  <div style={{ textAlign: "center", flexGrow: "1" }}>
                    <div className="report-subtle-tile">
                      BI2 technologies - Transport Report
                    </div>
                    <div className="report-primary-tile">
                      ANOKA COUNTY JAIL <br /> ANOKA, MN
                    </div>
                  </div>
                </StyledFlex>
              </StyledGridCol>
            </StyledGridRow>
            <StyledSectionHeading>
              <span>PERSONAL INFORMATION</span>
            </StyledSectionHeading>

            <StyledGridRow gutter={16}>
              <StyledGridCol xs={7}>
                <div className="report-flex-item">
                  <div className="key-value">{`${bookings?.bio?.[0]?.lName} ${bookings?.bio?.[0]?.fName}`}</div>
                </div>
              </StyledGridCol>
              <StyledGridCol xs={7}>
                <div className="report-flex-item">
                  <label className="key-title">Booking#:</label>
                  <div className="key-value">{bookings?.bookingId || ""}</div>
                </div>
              </StyledGridCol>
            </StyledGridRow>

            <StyledGridRow gutter={16}>
              <StyledGridCol xs={7}>
                <div className="report-flex-item">
                  <label className="key-title">Old CRH#:</label>
                  <div className="key-value"></div>
                </div>
                <div className="report-flex-item">
                  <label className="key-title">Race:</label>
                  <div className="key-value">
                    {bookings?.bio?.[0]?.race || ""}
                  </div>
                </div>
                <div className="report-flex-item">
                  <label className="key-title">Address:</label>
                  <div className="key-value"></div>
                </div>
                <div className="report-flex-item">
                  <label className="key-title">Phone:</label>
                  <div className="key-value">
                    {bookings?.bio?.[0]?.phone || ""}
                  </div>
                </div>
                <div className="report-flex-item">
                  <label className="key-title">DL#:</label>
                  <div className="key-value">
                    {bookings?.bio?.[0]?.dlNumber || ""}
                  </div>
                </div>
                <div className="report-flex-item">
                  <label className="key-title">FBI:</label>
                  <div className="key-value">
                    {bookings?.bio?.[0]?.fbi || ""}
                  </div>
                </div>
                <div className="report-flex-item">
                  <label className="key-title">SID:</label>
                  <div className="key-value">
                    {bookings?.bio?.[0]?.sid || ""}
                  </div>
                </div>
                <div className="report-flex-item">
                  <label className="key-title">Dominant Hand:</label>
                  <div className="key-value"></div>
                </div>
                <div className="report-flex-item">
                  <label className="key-title">
                    Health Insurance Policy #:
                  </label>
                  <div className="key-value"></div>
                </div>
                <div className="report-flex-item">
                  <label className="key-title">Employer:</label>
                  <div className="key-value"></div>
                </div>
                <div className="report-flex-item">
                  <label className="key-title">US Citizen:</label>
                  <div className="key-value"></div>
                </div>
              </StyledGridCol>
              <StyledGridCol xs={7}>
                <div className="report-flex-item">
                  <label className="key-title"> Alias:</label>
                  <div className="key-value">
                    {bookings?.bio?.[0]?.aliases || ""}
                  </div>
                </div>
                <div className="report-flex-item">
                  <label className="key-title"> Gender:</label>
                  <div className="key-value">
                    {bookings?.bio?.[0]?.sex || ""}
                  </div>
                </div>
                <div className="report-flex-item">
                  <label className="key-title">Height:</label>
                  <div className="key-value">
                    {bookings?.bio?.[0]?.height || ""}
                  </div>
                </div>
                <div className="report-flex-item">
                  <label className="key-title">Hair:</label>
                  <div className="key-value">
                    {bookings?.bio?.[0]?.hair || ""}
                  </div>
                </div>
                <div className="report-flex-item">
                  <label className="key-title">Glasses:</label>
                  <div className="key-value">
                    {bookings?.bio?.[0]?.glasses || ""}
                  </div>
                </div>
                <div className="report-flex-item">
                  <label className="key-title">Facial:</label>
                  <div className="key-value">
                    {bookings?.bio?.[0]?.facialHair || ""}
                  </div>
                </div>
                <div className="report-flex-item">
                  <label className="key-title">DOB:</label>
                  <div className="key-value">
                    {bookings?.bio?.[0]?.dob || ""}
                  </div>
                </div>
                <div className="report-flex-item">
                  <label className="key-title">SSN:</label>
                  <div className="key-value">
                    {bookings?.bio?.[0]?.ssn || ""}
                  </div>
                </div>
                <div className="report-flex-item">
                  <label className="key-title">Folder ID:</label>
                  <div className="key-value">{bookings?.jacketId || ""}</div>
                </div>
                <div className="report-flex-item">
                  <label className="key-title">Occupation:</label>
                  <div className="key-value"></div>
                </div>
                <div className="report-flex-item">
                  <label className="key-title">
                    Health Insurance Policy Holder:
                  </label>
                  <div className="key-value"></div>
                </div>
              </StyledGridCol>
              <StyledGridCol xs={7}>
                <div className="report-flex-item">
                  <label className="key-title">
                    Emergency Contact Comments:
                  </label>
                  <div className="key-value">
                    {bookings?.bio?.[0]?.emergencyContactComments || ""}
                  </div>
                </div>
                <div className="report-flex-item">
                  <label className="key-title">Vehicle Info:</label>
                  <div className="key-value"></div>
                </div>
                <div className="report-flex-item">
                  <label className="key-title">Weight:</label>
                  <div className="key-value">
                    {bookings?.bio?.[0]?.weight || ""}
                  </div>
                </div>
                <div className="report-flex-item">
                  <label className="key-title">Eyes:</label>
                  <div className="key-value">
                    {bookings?.bio?.[0]?.eyes || ""}
                  </div>
                </div>
                <div className="report-flex-item">
                  <label className="key-title">Length:</label>
                  <div className="key-value"></div>
                </div>
                <div className="report-flex-item">
                  <label className="key-title">Comp:</label>
                  <div className="key-value">
                    {bookings?.bio?.[0]?.complexion || ""}
                  </div>
                </div>
                <div className="report-flex-item">
                  <label className="key-title">POB:</label>
                  <div className="key-value">
                    {bookings?.bio?.[0]?.placeOfBirthCountry || ""}
                  </div>
                </div>
                <div className="report-flex-item">
                  <label className="key-title">Health Insurance Carrier:</label>
                  <div className="key-value"></div>
                </div>
                <div className="report-flex-item">
                  <label className="key-title">OID:</label>
                  <div className="key-value"></div>
                </div>
                <div className="report-flex-item">
                  <label className="key-title">Alien Registration #:</label>
                  <div className="key-value"></div>
                </div>
              </StyledGridCol>
              <StyledGridCol xs={3}>
                <div className="report-profile-img">
                  <div className="report-no-image">
                    <img
                      src={
                        PHOTOS_BASE_URL +
                        getFinalPath(
                          bookings?.bio?.[0]?.bioPhotos?.[0]?.photos[0]
                            ?.fullSizePath
                        )
                      }
                      alt={"No Image"}
                    />
                  </div>
                </div>
              </StyledGridCol>
            </StyledGridRow>

            <StyledSectionHeading>
              <span>ARREST INFORMATION</span>
            </StyledSectionHeading>

            <StyledGridRow gutter={16}>
              <StyledGridCol xs={5}>
                <div className="report-flex-item">
                  <label className="key-title">Booking Number:</label>
                  <div className="key-value">
                    {bookings?.arrestReports?.[0]?.bookingId || ""}
                  </div>
                </div>
                <div className="report-flex-item">
                  <label className="key-title">Offense Date/Time:</label>
                  <div className="key-value">
                    {bookings?.arrestReports?.[0]?.offenseDate
                      ? `${bookings?.arrestReports?.[0]?.offenseDate} / ${bookings?.arrestReports?.[0]?.offenseTime}`
                      : ""}
                  </div>
                </div>
                <div className="report-flex-item">
                  <label className="key-title">Current Location:</label>
                  <div className="key-value">
                    {bookings?.arrestReports?.[0]?.currentLocation || ""}
                  </div>
                </div>
              </StyledGridCol>
              <StyledGridCol xs={5}>
                <div className="report-flex-item">
                  <label className="key-title">Arresting Agency:</label>
                  <div className="key-value">
                    {bookings?.arrestReports?.[0]?.agency || ""}
                  </div>
                </div>
                <div className="report-flex-item">
                  <label className="key-title">Arrest Date/Time:</label>
                  <div className="key-value">
                    {bookings?.arrestReports?.[0]?.arrestDate
                      ? `${bookings?.arrestReports?.[0]?.arrestDate} / ${bookings?.arrestReports?.[0]?.arrestTime}`
                      : ""}
                  </div>
                </div>
                <div className="report-flex-item">
                  <label className="key-title">Arrest Location:</label>
                  <div className="key-value">
                    {bookings?.arrestReports?.[0]?.arrestLocation || ""}
                  </div>
                </div>
              </StyledGridCol>
              <StyledGridCol xs={5}>
                <div className="report-flex-item">
                  <label className="key-title">Jail ORI:</label>
                  <div className="key-value"></div>
                </div>
                <div className="report-flex-item">
                  <label className="key-title">Sched.Rel.Date/Time:</label>
                  <div className="key-value"></div>
                </div>
                <div className="report-flex-item">
                  <label className="key-title">ArrestCity:</label>
                  <div className="key-value">
                    {bookings?.arrestReports?.[0]?.arrestCity || ""}
                  </div>
                </div>
              </StyledGridCol>
              <StyledGridCol xs={4}>
                <div className="report-flex-item">
                  <label className="key-title">Arresting Officer:</label>
                  <div className="key-value">
                    {bookings?.arrestReports?.[0]?.officer || ""}
                  </div>
                </div>
                <div className="report-flex-item">
                  <label className="key-title">Release Date/Time:</label>
                  <div className="key-value">
                    {bookings?.arrestReports?.[0]?.releaseDate
                      ? `${bookings?.arrestReports?.[0]?.releaseDate} / ${bookings?.arrestReports?.[0]?.releaseTime}`
                      : ""}
                  </div>
                </div>
              </StyledGridCol>
              <StyledGridCol xs={4}>
                <div className="report-flex-item">
                  <label className="key-title">Booking Officer:</label>
                  <div className="key-value">
                    {bookings?.arrestReports?.[0]?.bookingOfficer || ""}
                  </div>
                </div>
                <div className="report-flex-item">
                  <label className="key-title">Housed:</label>
                  <div className="key-value">
                    {bookings?.arrestReports?.[0]?.housed || ""}
                  </div>
                </div>
              </StyledGridCol>
            </StyledGridRow>

            <StyledSectionHeading>
              <span>DETENTIONS</span>
            </StyledSectionHeading>

            <StyledGridRow gutter={16}>
              <StyledGridCol xs={24} marginBottom="20px">
                <Table
                  variant="outlined"
                  headers={[
                    { key: "id", text: "Detention #" },
                    { key: "agency", text: "Agency" },
                    { key: "start", text: "Start" },
                    { key: "end", text: "End" },
                    { key: "releaseReason", text: "Release Reason" },
                  ]}
                  data={bookings?.detentions?.[0]?.detentionsArrestReports?.map(
                    (detention) => ({
                      id: bookings?.bookingNumber || "",
                      agency: detention?.housingAgency || "",
                      start: detention?.incarcerationDate
                        ? `${detention?.incarcerationDate} ${detention?.incarcerationTime}`
                        : "",
                      end: detention?.releaseDate
                        ? `${detention?.releaseDate} ${detention?.releaseTime}`
                        : "",
                      releaseReason:
                        getRefListNameByID(
                          "Release_Reason",
                          detention?.releaseReasonId
                        ) || "",
                    })
                  )}
                />
                <div className="table-total-row">
                  Total Number of Rows:{" "}
                  {bookings?.detentions?.[0]?.detentionsArrestReports?.length}
                </div>
              </StyledGridCol>
            </StyledGridRow>

            <StyledSectionHeading>
              <span>CHARGES</span>
            </StyledSectionHeading>

            <StyledGridRow gutter={16}>
              <StyledGridCol xs={24} marginBottom="20px">
                <Table
                  variant="outlined"
                  headers={[
                    { key: "id", text: "ID" },
                    { key: "charge", text: "Charge" },
                    { key: "cleared", text: "Cleared?" },
                    { key: "clearedOn", text: "Cleared On" },
                    { key: "clearanceReason", text: "Clearance Reason" },
                    { key: "bailId", text: "Bail ID" },
                    { key: "originalCharges", text: "Original Charge" },
                    { key: "caseNumber", text: "Case Number" },
                    { key: "courtNumber", text: "Court Number" },
                  ]}
                  data={
                    bookings?.charges?.map((charge, index) => ({
                      id: charge?.sequence || index + 1,
                      charge:
                        getRefListNameByID(
                          "Charges",
                          charge?.chargeDescriptionID
                        ) || "",
                      cleared: charge?.clearedToGo ? "True" : "False",
                      clearedOn: charge?.clearanceDate
                        ? `${charge?.clearanceDate} ${charge?.clearanceTime}`
                        : "",
                      clearanceReason: getRefListNameByID(
                        "clearance_reason",
                        charge?.chargeDescriptionID
                      ),
                    })) || []
                  }
                />
                <div className="table-total-row">
                  Total Number of Rows: {bookings?.charges?.length}
                </div>
              </StyledGridCol>
            </StyledGridRow>

            <StyledSectionHeading>
              <span>BONDS</span>
            </StyledSectionHeading>

            <StyledGridRow gutter={16}>
              <StyledGridCol xs={24} marginBottom="20px">
                <Table
                  variant="outlined"
                  headers={[
                    { key: "bailAmount", text: "Bail Amount" },
                    { key: "courtNumber", text: "Court Number" },
                    { key: "bailType", text: "Bail Type" },
                    { key: "paid", text: "Paid" },
                    { key: "receiptNumber", text: "Receipt Number" },
                    { key: "bailID", text: "Bail ID" },
                  ]}
                  data={bookings?.bookingBails?.map((bail, index) => ({
                    bailAmount: bail?.bailAmount,
                    courtNumber: bail?.courtNumber,
                    bailType: isNonEmptyVariable(bail?.bailTypeID)
                      ? getRefListNameByID("BondType", bail?.bailTypeID)
                      : "",
                    paid: bail?.paid ? "True" : "False",
                    receiptNumber: "",
                    bailID: index + 1,
                  }))}
                />
                <div className="table-total-row">
                  <small>Total Unpaid Bail: 0</small>
                </div>

                <div className="table-total-row">
                  <small>Comments: 0</small>
                </div>
              </StyledGridCol>
            </StyledGridRow>

            <StyledSectionHeading>
              <span>HOLDS</span>
            </StyledSectionHeading>

            <StyledGridRow gutter={16}>
              <StyledGridCol xs={24} marginBottom="20px">
                <Table
                  variant="outlined"
                  headers={[
                    { key: "holdReason", text: "Hold Reason" },
                    { key: "holdFor", text: "Hold For" },
                    { key: "holdContact", text: "Hold Contact" },
                    { key: "holdContactPhone", text: "Hold Contact Phone" },
                    { key: "holdStatus", text: "Hold Status" },
                    { key: "comments", text: "Comments" },
                  ]}
                  data={bookings?.holds?.map((hold) => ({
                    holdReason: getOptionsFromRefList(
                      "Hold_Reason",
                      false,
                      false,
                      true
                    ).filter(
                      (data) => parseInt(hold.holdReason) === data?.value
                    )?.[0]?.label,
                    holdFor: hold?.holdFor,
                    holdContact: hold?.holdContact,
                    holdContactPhone: hold?.holdContactPhone,
                    holdStatus: getOptionsFromRefList(
                      "Hold_Status",
                      false,
                      false,
                      true
                    ).filter(
                      (data) => parseInt(hold.holdStatus) === data?.value
                    )?.[0]?.label,
                    comments: hold?.comments,
                  }))}
                />
                <div className="table-total-row">
                  Total Number of Rows: {bookings?.holds?.length}
                </div>
              </StyledGridCol>
            </StyledGridRow>

            <StyledSectionHeading>
              <span>ASSOCIATES</span>
            </StyledSectionHeading>

            <StyledGridRow gutter={16}>
              <StyledGridCol xs={24} marginBottom="20px">
                <Table
                  variant="outlined"
                  headers={[
                    { key: "fullName", text: "Full Name" },
                    { key: "asscoiateType", text: "Asscoiate Type" },
                    { key: "homePhone", text: "Home Phone" },
                    { key: "workPhone", text: "Work Phone" },
                    { key: "comments", text: "Comments" },
                  ]}
                  data={bookings?.bookingsJacketsJackets?.map((item) => ({
                    ...item.jacketsJackets?.[0],
                    fullName: `${
                      item.jacketsJackets?.[0]?.jackets?.[0]?.bio?.[0]?.fName ||
                      ""
                    } ${
                      item.jacketsJackets?.[0]?.jackets?.[0]?.bio?.[0]?.mName ||
                      ""
                    } ${
                      item.jacketsJackets?.[0]?.jackets?.[0]?.bio?.[0]?.lName ||
                      ""
                    }`.trim(),
                    asscoiateType: getOptionsFromRefList(
                      "Inmate_Associate_Type",
                      false,
                      false,
                      true
                    ).filter(
                      (opt) =>
                        opt.value === item.jacketsJackets?.[0].associateTypeID
                    )?.[0]?.label,
                    homePhone:
                      item.jacketsJackets?.[0]?.jackets?.[0]?.bio?.[0]?.phone,
                    workPhone:
                      item.jacketsJackets?.[0]?.jackets?.[0]?.bio?.[0]
                        ?.daytimePhone,
                  }))}
                />
                <div className="table-total-row">
                  Total Number of Rows:{" "}
                  {bookings?.bookingsJacketsJackets?.jacketsJackets?.length}
                </div>
              </StyledGridCol>
            </StyledGridRow>

            <StyledGridRow
              style={{ marginBottom: "20px", marginTop: "20px" }}
              gutter={20}
            >
              <StyledGridCol span={5}>
                <div className="sign-form-check">
                  Transporting Officer - print{" "}
                </div>
                <div className="sign-form-check">Receiving Officer - print</div>
              </StyledGridCol>
              <StyledGridCol span={5}>
                <div className="sign-form-check"> Signature </div>
                <div className="sign-form-check">Signature</div>
              </StyledGridCol>
              <StyledGridCol span={4}>
                <div className="sign-form-check">Beg. Mileage</div>
                <div className="sign-form-check"> End. Mileage</div>
              </StyledGridCol>
              <StyledGridCol span={3}>
                <div className="sign-form-check"> Date </div>
                <div className="sign-form-check"> Date </div>
              </StyledGridCol>
              <StyledGridCol span={3}>
                <div className="sign-form-check">Time</div>
                <div className="sign-form-check"> Time</div>
              </StyledGridCol>
            </StyledGridRow>
          </StyledReportContent>
        </StyledReportContainer>
      </Modal>
    </>
  );
};
export default TransportDocumentModal;
